
export const getThousandth = (num?: any) => {
   const number = Number(num);
   return number.toLocaleString('zh-CN');
};